import React from 'react'
import { Stack } from '@mui/material'
import { ComparisonTableProps } from './_props'
import ComparisonTableRow from './ComparisonTableRow'
import { generateRandomGuiID } from '../../../utils/commonUtils'
import { comparisonTableHeaderRowData } from './_utils'
import sxs from './ComparisonTable.sxs'

const ComparisonTable: React.FC<ComparisonTableProps> = ({ data }) => (
    <Stack width="100%" sx={sxs.comparisonTable}>
        {/* table header */}
        <ComparisonTableRow items={comparisonTableHeaderRowData} />
        {/* table body */}
        {data?.map((rowData) => <ComparisonTableRow key={generateRandomGuiID()} items={rowData.items} />)}
    </Stack>
)

export default ComparisonTable
